import type { RequestContext } from "../context/request-context.js";
import { selectedNdtAssetIds } from "./ndt-asset-report-usage.js";

/** Referência contextual: o instrumento é global, mas o uso é sempre do Cliente do relatório. */
export interface NdtAssetReportUsage {
  documentType: "ME" | "PM" | "USC" | "BSCAN";
  reportId: string;
  reportNumber: string;
  clientId: string;
  projectId: string | null;
  equipmentTag: string;
  testDate: string;
  status: string;
}

type ReportEntry = {
  id: string; clientId: unknown; reportNumber?: string; projectId?: string | null;
  equipmentTag?: string; testDate?: string; status?: string;
  deviceAssetId?: string | null; transducerAssetId?: string | null;
  yokeAssetId?: string | null; calibrationBlockAssetId?: string | null;
  transducers?: Array<{ assetId?: string | null }>;
};
export type ReadonlyNdtReportSource = {
  listAll?: () => Promise<readonly ReportEntry[]>;
};
export function createNdtAssetUsageLister(sources: {
  me?: ReadonlyNdtReportSource;
  pm?: ReadonlyNdtReportSource;
  usc?: ReadonlyNdtReportSource;
  bscan?: ReadonlyNdtReportSource;
}) {
  return async (context: RequestContext, assetId: string): Promise<NdtAssetReportUsage[]> => {
    // Nunca retornar relatórios de outros Clientes nem inferir permissões do catálogo global.
    const clientId = context.activeClientId ? String(context.activeClientId) : "";
    if (!clientId) return [];
    const out: NdtAssetReportUsage[] = [];
    const repositories = [
      ["ME", sources.me], ["PM", sources.pm], ["USC", sources.usc], ["BSCAN", sources.bscan]
    ] as const;
    for (const [documentType, source] of repositories) {
      if (!source?.listAll) continue;
      for (const report of await source.listAll()) {
        if (String(report.clientId) !== clientId) continue;
        if (!selectedNdtAssetIds(report).includes(assetId)) continue;
        out.push({
          documentType, reportId: report.id,
          reportNumber: report.reportNumber ?? "",
          clientId, projectId: report.projectId ?? null,
          equipmentTag: report.equipmentTag ?? "",
          testDate: report.testDate ?? "", status: report.status ?? ""
        });
      }
    }
    return out.sort((a, b) => b.testDate.localeCompare(a.testDate) || a.reportId.localeCompare(b.reportId)).slice(0, 100);
  };
}
